import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, inject, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { FusionService } from '@shared-angular/services/fusion.service';
import { FrontendUrlsService } from '@shared-angular/services/frontend-urls.service';
import { LanguageService } from '@shared-angular/services/language.service';
import { LoginService } from '@shared-angular/services/login.service';
import { ToastrService } from '@shared-angular/services/toastr.service';
import { normalizeEmbedOrigin, parseEmbedOrigins } from '@shared/index';
import { Highlight } from 'ngx-highlightjs';
import { BlockUIModule } from 'primeng/blockui';
import { Button } from "primeng/button";
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputText } from 'primeng/inputtext';
import { Popover, PopoverModule } from 'primeng/popover';
import { SelectModule } from 'primeng/select';
import { TabsModule } from 'primeng/tabs';
import { TextareaModule } from 'primeng/textarea';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { RouteShareService } from 'src/app/shared/services/route-share.service';
import { SharetokenService } from 'src/app/shared/services/sharetoken.service';
import { ZipexportService, ZipExportType } from 'src/app/shared/services/zipexport/zipexport.service';
import { BotService } from '../../../../../../shared/services/bot.service';

import { TooltipModule } from 'primeng/tooltip';
export interface ExportOptionBotType {
  name: string;
  urlSuffix: string;
  fusionId: string | null
  type: "default" | "fusion"
  zipType: ZipExportType;
}





interface ExportOptionBotLanguage {
  name: string;
  code: "de" | "en" | "fr" | "es" | "it" | "nl" | "nb-no" | "fr-be" | "nl-be" | "pl" | "pt" | "hu" | "ro" | "tr" | "fi" | "sv" | "da" | "cs" | "el"
}

interface ExportOptionEmbedType {
  name: string;
  code: "iframe" | "flyover"
}




@Component({
  selector: 'app-export-drawer-content',
  imports: [RouterLink, NgClass, NgTemplateOutlet, TooltipModule, FormsModule, TabsModule, SelectModule, FloatLabelModule, Button, TextareaModule, Highlight, ToggleSwitchModule, BlockUIModule, PopoverModule, InputText],
  templateUrl: './embed-tab.component.html',
  styleUrl: './embed-tab.component.scss'
})
export class EmbedTabComponent {
  public readonly closeDrawer = output();
  private readonly frontendUrls = inject(FrontendUrlsService);
  public exportLink: string = '';
  // EMBED TYPES
  public selectedEmbedType: ExportOptionEmbedType = { name: 'Iframe - Anzeige direkt in der Website', code: 'iframe' };
  public embedTypes: ExportOptionEmbedType[] = [
    { name: 'Iframe - Anzeige direkt in der Website', code: 'iframe' },
    { name: 'Flyover - Erzeugt einen Bot-Button unten rechts', code: 'flyover' }
  ];
  public draggableFlyoverButton = false;



  // EXPORT LANGUAGE
  public selectedLanguage: ExportOptionBotLanguage = { name: 'Deutsch', code: 'de' };
  public exportLanguages: ExportOptionBotLanguage[] = [
    { name: $localize`:@@fusionconfig-systemlang-de:Deutsch`, code: 'de' },
    { name: $localize`:@@fusionconfig-systemlang-en:Englisch`, code: 'en' },
    { name: $localize`:@@fusionconfig-systemlang-fr:Französisch`, code: 'fr' },
    { name: $localize`:@@fusionconfig-systemlang-es:Spanisch`, code: 'es' },
    { name: $localize`:@@fusionconfig-systemlang-it:Italienisch`, code: 'it' },
    { name: $localize`:@@fusionconfig-systemlang-nl:Niederländisch`, code: 'nl' },
    { name: $localize`:@@fusionconfig-systemlang-nb:Norwegisch`, code: 'nb-no' },
    { name: $localize`:@@fusionconfig-systemlang-fr-be:Französisch (Belgien)`, code: 'fr-be' },
    { name: $localize`:@@fusionconfig-systemlang-nl-be:Niederländisch (Belgien)`, code: 'nl-be' },
    { name: $localize`:@@fusionconfig-systemlang-pl:Polnisch`, code: 'pl' },
    { name: $localize`:@@fusionconfig-systemlang-pt:Portugiesisch`, code: 'pt' },
    { name: $localize`:@@fusionconfig-systemlang-hu:Ungarisch`, code: 'hu' },
    { name: $localize`:@@fusionconfig-systemlang-ro:Rumänisch`, code: 'ro' },
    { name: $localize`:@@fusionconfig-systemlang-tr:Türkisch`, code: 'tr' },
    { name: $localize`:@@fusionconfig-systemlang-fi:Finnisch`, code: 'fi' },
    { name: $localize`:@@fusionconfig-systemlang-sv:Schwedisch`, code: 'sv' },
    { name: $localize`:@@fusionconfig-systemlang-da:Dänisch`, code: 'da' },
    { name: $localize`:@@fusionconfig-systemlang-cs:Tschechisch`, code: 'cs' },
    { name: $localize`:@@fusionconfig-systemlang-el:Griechisch`, code: 'el' }
  ];

  public urlSubFixes = ['', '/audio', '/avatar'];
  public hasBeenExportButtonPressed: boolean = false;

  constructor(
    private toastr: ToastrService,
    private SharetokenService: SharetokenService,
    public zipService: ZipexportService,

    private langService: LanguageService,
    public rss: RouteShareService,
    public botService: BotService,
    public fusionService: FusionService,
    public loginService: LoginService
  ) { }


  // EXPORT TYPES
  public selectedExportType: ExportOptionBotType = { name: 'Chatbot', urlSuffix: 'chat', fusionId: null, type: 'default', zipType: "chat" };
  public exportTypes: ExportOptionBotType[] = [
    { name: 'Chatbot', urlSuffix: 'chat', fusionId: null, type: 'default', zipType: "chat" },
    { name: 'Audio Bot', urlSuffix: 'audio', fusionId: null, type: 'default', zipType: "audio" },
    { name: 'Avatar Nova', urlSuffix: 'avatar-nova', fusionId: null, type: 'default', zipType: "avatar" },
    { name: 'Avatar Vega', urlSuffix: 'avatar-vega', fusionId: null, type: 'default', zipType: "avatar" }
  ];

  public getExportTypes(): ExportOptionBotType[] {
    // Start with the default export types
    const r: ExportOptionBotType[] = [...this.exportTypes];

    // If fusionContent exists and is an array, add fusion export types
    if (Array.isArray(this.fusionService.fusionContent)) {
      for (const fusionContent of this.fusionService.fusionContent) {
        r.push({
          name: "(Fusion) " + fusionContent.metadata.name + " - " + fusionContent.metadata.type + " - " + fusionContent.metadata.bottype,
          urlSuffix: '',
          fusionId: fusionContent._id,
          type: 'fusion',
          zipType: "fusion"
        });
      }
    }

    return r;
  }



  public getQRUrl(): string {
    return '/api/qrcode?text=' + this.getDirectLink();
  }

  public getDirectLink(): string {
    if (this.selectedExportType.type === "fusion" && this.selectedExportType.fusionId) {
      return this.frontendUrls.bot("/" + this.selectedLanguage.code + '/fusion/' + this.rss.botConfig._id + '/' + this.selectedExportType.fusionId);
    }

    return this.frontendUrls.bot("/" + this.selectedLanguage.code + '/bot/' + this.rss.botConfig._id + '/' + this.selectedExportType.urlSuffix);
  }

  public getEmbedScriptUrl(): string {
    let file = "embed.js";
    if (this.selectedEmbedType.code === "iframe") {
      file = "embed-iframe.js";
    }
    return this.frontendUrls.bot("/" + this.selectedLanguage.code + '/assets/' + file);
  }

  public async exportBot() {
    const token = await this.SharetokenService.getShareToken(this.rss.botConfig._id);
    if (token) {
      this.exportLink = (window.location.href).split('/').slice(0, 3).join('/') + "/bot-import/" + token.shareToken;
      this.toastr.success("LINK_GENERATED");
      this.hasBeenExportButtonPressed = true;
      this.copyToClipboardLink(this.exportLink);
    } else {
      this.toastr.error("LINK_GENERATED");
    }
  }

  public generateEmbedCode() {
    const isIframe = this.selectedEmbedType.code === "iframe";
    let r = "// reflact AI Chatbot Embed Code\n";
    r += isIframe ? "<div id=\"targetdiv\" style=\"width: 100 %; height: 600px;\"> </div>\n" : "";

    r += "<script ";
    r += `  data-url="${this.getDirectLink()}"\n`;
    r += isIframe ? "data-target=\"targetdiv\"\n" : "";
    r += !isIframe && this.draggableFlyoverButton ? "data-draggable=\"true\"\n" : "";
    r += `src="${this.getEmbedScriptUrl()}"\n`;
    r += `></script>`;
    return r;
  }

  protected saveCustomPw() {
    if (this.rss.botConfig.botPassword.trim() === '') {
      this.toastr.error("GENERAL", 'Bitte gib ein Passwort ein.');
    } else if (this.rss.botConfig.botPassword.length < 4) {
      this.toastr.error("GENERAL", 'Das Passwort muss mindestens 4 Zeichen lang sein');
    } else {
      void this.rss.saveBotConfigField("botPassword");
    }
  }

  public downloadZipName(trackingEnabled = false, type: 'scorm' | 'scorm2004' | 'xapi' | 'pod'): string {
    const e_name = this.rss.botConfig;
    const e_lang = this.selectedLanguage.code.toUpperCase();
    const e_view = this.selectedExportType.name.replace(/ /g, '_');
    const e_tracking = trackingEnabled ? '_tracking' : '';
    const fullName = `${e_name.name.replace(/[^a-zA-Z0-9]/g, '_')}_${e_view}_${type}_${e_lang}${e_tracking}`;
    return fullName;
  }

  public copyToClipboard(element: HTMLInputElement) {
    element.select();
    void navigator.clipboard.writeText(element.value);
    element.setSelectionRange(0, 0);
    this.toastr.info("LINK_COPIED");
  }
  public copyToClipboardTxt(text: string) {
    void navigator.clipboard.writeText(text);
    this.toastr.baseToastr.success($localize`:@@t-info-code-copied:Code kopiert`);
  }
  public copyToClipboardLink(text: string) {
    void navigator.clipboard.writeText(text);
    this.toastr.success("LINK_COPIED");
  }

  public copyPasswordToClipboard() {
    void navigator.clipboard.writeText(this.rss.botConfig.botPassword || '');
    this.toastr.success("GENERAL", $localize`:@@clipboard-copy-success:Text kopiert`);
  }

  // Allowed embedding/LMS origins (#565), stored comma-separated in postMessageTargetOrigin.
  protected embedOrigins: string[] = [];
  protected newEmbedOrigin = '';

  protected embedAllowedEverywhere(): boolean {
    return this.rss.botConfig.postMessageTargetOrigin.trim() === '*';
  }

  protected embedOriginsStateLabel(): string {
    if (this.embedAllowedEverywhere()) return $localize`:@@embed-origins-state-everywhere:Überall erlaubt`;
    const parsed = parseEmbedOrigins(this.rss.botConfig.postMessageTargetOrigin);
    if (parsed.mode === 'unrestricted') return $localize`:@@embed-origins-state-none:Keine Domain eingetragen – überall möglich`;
    return parsed.origins.length === 1
      ? $localize`:@@embed-origins-state-one:1 Domain`
      : $localize`:@@embed-origins-state-many:${parsed.origins.length}:count: Domains`;
  }

  protected openEmbedOrigins(popover: Popover, event: Event) {
    const parsed = parseEmbedOrigins(this.rss.botConfig.postMessageTargetOrigin);
    this.embedOrigins = parsed.mode === 'list' ? [...parsed.origins] : [];
    this.newEmbedOrigin = '';
    popover.show(event);
  }

  protected async addEmbedOrigin() {
    if (this.newEmbedOrigin.trim() === '') return;
    const origin = normalizeEmbedOrigin(this.newEmbedOrigin);
    if (origin == null) {
      this.toastr.error("GENERAL", $localize`:@@embed-origins-invalid:Das ist keine gültige Domain. Gib sie z. B. so ein: https://lms.example.com`);
      return;
    }
    if (!this.embedOrigins.includes(origin)) this.embedOrigins.push(origin);
    this.newEmbedOrigin = '';
    await this.saveEmbedOrigins();
  }

  protected async removeEmbedOrigin(origin: string) {
    this.embedOrigins = this.embedOrigins.filter(o => o !== origin);
    await this.saveEmbedOrigins();
  }

  protected async setEmbedEverywhere(everywhere: boolean) {
    this.rss.botConfig.postMessageTargetOrigin = everywhere ? '*' : this.embedOrigins.join(',');
    await this.rss.saveBotConfigField('postMessageTargetOrigin');
  }

  private async saveEmbedOrigins() {
    if (this.embedAllowedEverywhere()) return;
    this.rss.botConfig.postMessageTargetOrigin = this.embedOrigins.join(',');
    await this.rss.saveBotConfigField('postMessageTargetOrigin');
  }

  public async onTemplateToggle(isTemplate: boolean) {
    this.rss.botConfig.isTemplate = isTemplate;
    await this.rss.saveBotConfigField('isTemplate');
  }
}
